export default __webpack_public_path__ + "static/media/doge.0ef8bce5.png";